import React from "react";
import DarkModeToggle from "react-dark-mode-toggle";

const Switch = ({isDarkMode, setIsDarkMode}) => {
  return (
    <div style = {{padding: `0 0 5px 25px`}}>
      <DarkModeToggle
        onChange={() => setIsDarkMode(!isDarkMode)}
        checked={isDarkMode}
        size={45}
      />
    </div>
  );
};

export default Switch;